<div class="login">
    <h1 class="sr-only">{{ 'Reset your password' | translate }}</h1>
    <div class="login__content">
        <core-brand-logo [isNotLink]="true"></core-brand-logo>
        <div class="login__wrapper">
            <p>
                <a class="login__goback" routerLink="/login">
                    <svg class="login__goback-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129">
                        <path
                            d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z" />
                    </svg>
                    {{ 'Go back' | translate }}
                </a>
            </p>

            <h2 class="login__reset-heading">
                {{ 'Password reset' | translate }}
                <core-dark-mode-toggle class="float-end" [moonDark]="true"></core-dark-mode-toggle>
            </h2>

            <p>
                {{ 'If you have forgotten your password, enter your email address to reset it.' | translate }}
            </p>

            @if (errorMessage) {
                <div class="alert alert-danger" [innerHTML]="errorMessage"></div>
            }
            @if (successMessage) {
                <div class="alert alert-success" [innerHTML]="successMessage"></div>
            }

            <form [formGroup]="resetForm" (ngSubmit)="reset()">
                <div
                    [ngClass]="{
                        'form-group--success': resetForm.get('email')!.valid,
                        'form-group--error': resetForm.get('email')!.touched && !resetForm.get('email')!.valid,
                    }"
                    class="form-group">
                    <label for="email">
                        {{ 'Email address' | translate }} *
                        <span class="sr-only">{{ 'required' | translate }}</span>
                    </label>
                    <div class="form-control-wrapper">
                        <input
                            autocomplete="off"
                            class="form-control"
                            formControlName="email"
                            id="email"
                            name="email"
                            type="email" />
                        <span
                            [hidden]="!resetForm.get('email')!.valid"
                            aria-live="polite"
                            class="form-control-feedback">
                            <span class="sr-only">{{ 'Correct' | translate }}</span>
                        </span>
                    </div>
                    <p
                        [hidden]="resetForm.get('email')!.valid || !resetForm.get('email')!.touched"
                        aria-live="polite"
                        class="small text-danger unconfirmed">
                        {{ 'Please enter a valid email address' | translate }} e.g. example&#64;mail.com
                    </p>
                </div>

                <div class="row no-gutters">
                    <div class="col-6 align-self-center">
                        <!--                        <a class="login-link" routerLink="/login-faqs">{{ 'Need help?' | translate }}</a>-->
                    </div>
                    <div class="col-6 pl-lg-1 my-2">
                        <button
                            [class.spinner]="submitting"
                            [disabled]="submitting || !resetForm.valid"
                            class="btn btn-primary btn-block btn-lg mb-0 float-end"
                            id="js-reset-btn"
                            type="submit">
                            <core-spinner name="reset"></core-spinner>
                            <span>{{ 'Reset' | translate }}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <core-login-footer></core-login-footer>
    </div>

    <core-demo-config-toggle></core-demo-config-toggle>
</div>
